import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { OrganizationService } from 'src/app/core/service/organization.service';

@Injectable({
    providedIn: 'root'
})
export class OrganizationValidators
{
    private extensionExistsRequests = new Map<string, Observable<any>>();

    constructor(private organizationService: OrganizationService) { }

    public validateOrganizationNameUnique(control: UntypedFormControl, initialOrganizationName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialOrganizationName !== control.value)
            {
                this.organizationService.existsOrganizationName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }

        });
    }

    public validateOrganizationKeyUnique(
        control: UntypedFormControl,
        organizationId: number,
        extensionId: number,
        category: string,
        unchangedSnapshot?: { key: string; organizationId: number | null; category: string } | null): any
    {
        return new Promise(resolve =>
        {
            if (control === null || control.value === '' || category === null)
            {
                resolve(null);
                return;
            }

            if (extensionId > 0 && unchangedSnapshot &&
                control.value === unchangedSnapshot.key &&
                organizationId === unchangedSnapshot.organizationId &&
                category === unchangedSnapshot.category)
            {
                resolve(null);
                return;
            }

            const cacheKey = `${control.value}|${organizationId}|${category}`;
            let request = this.extensionExistsRequests.get(cacheKey);
            if (!request)
            {
                request = this.organizationService.existsSettingExtension(control.value, organizationId, category).pipe(
                    shareReplay(1),
                    finalize(() => this.extensionExistsRequests.delete(cacheKey))
                );
                this.extensionExistsRequests.set(cacheKey, request);
            }

            request.subscribe({
                next: (response) =>
                {
                    if (response !== null && response.id !== extensionId)
                    {
                        resolve({ keyExists: true });
                    }
                    else
                    {
                        resolve(null);
                    }
                },
                error: () => resolve(null)
            });
        });
    }
}
